export default __webpack_public_path__ + "static/media/Manrope-ExtraLight.e638c538.woff";